import OapGenericDataProvider from './code/Scripts/components/OapGenericDataProvider.vue';

export default {
  components: {
    OapGenericDataProvider,
  },
};
